var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6244 9.19045C17.62 9.34466 17.5868 9.49668 17.5263 9.63862C17.4592 9.77854 17.3693 9.90633 17.2602 10.0168L12.6105 14.6665C12.3886 14.8805 12.0924 15 11.7842 15C11.476 15 11.1797 14.8805 10.9579 14.6665L6.30812 10.0168C6.11132 9.7917 6.00197 9.50341 6 9.20445C6.00024 9.05574 6.03009 8.90857 6.0878 8.77151C6.14551 8.63445 6.22993 8.51025 6.33613 8.40615C6.54259 8.16875 6.83463 8.02272 7.14843 8C7.44739 8.00197 7.73568 8.11132 7.96074 8.30812L11.8122 12.2016L15.6356 8.37814C15.7461 8.2691 15.8739 8.17918 16.0138 8.11204C16.1601 8.04986 16.317 8.01657 16.4759 8.01401C16.6293 8.01356 16.7813 8.04207 16.9241 8.09804C17.0715 8.15273 17.2054 8.2386 17.3166 8.34979C17.4278 8.46098 17.5137 8.59486 17.5684 8.74228C17.6145 8.88694 17.6335 9.03888 17.6244 9.19045Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlack);
export default __webpack_public_path__ + "static/media/DownArrowBlack.b3d361cbfe547151e677f4d1a29cc6f7.svg";
export { ForwardRef as ReactComponent };